<template>
  <div class="card order-info">
    
    <div class="info">
      <van-row class="info-line">
          <van-col :span="8">
            提货申请
          </van-col>
          <van-col :span="16">
            <span class="info-title">申请时间：</span>
            <span class="info-value">
              {{ $utils.formatDateTime(order.createTime) }}
              <!-- <router-link to="/home" class="order-no">{{ order.orderNo }}</router-link> -->
            </span>
          </van-col>
      </van-row>
      <!-- <van-row class="info-line">
        <van-col :span="12">
          <span class="info-title">订单类型：</span>
          <span class="info-value">{{ order.tradeType | convertStatus }} </span>
        </van-col>
      </van-row> -->
      <van-row class="info-line">
        <van-col :span="24">
          <span class="info-title">订单号：</span>
          <span class="info-value">
            {{ order.orderNo }}
          </span>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <span class="info-title">卖家：</span>
        <span class="info-value">{{ order.sellerEnterpriseName }}</span>
      </van-row>
      <van-row class="info-line">
        <span class="info-title">仓库名称：</span>
        <span class="info-value">{{ productData.warehouseName }}</span>
      </van-row>
      <van-row class="info-line">
        <span class="info-title">提货地点：</span>
        <span class="info-value">{{ productData.deliveryAddress }}</span>
      </van-row>
      <van-row class="info-line">
        <van-col :span="12" >
          <span class="info-title">交货方式：</span>
          <span v-if="productData.deliveryMode == '1'" class="info-value">自提</span>
          <span v-if="productData.deliveryMode == '2'" class="info-value">配送</span>
        </van-col>
        <van-col :span="12">
          <span class="info-title">发货方式：</span>
          <span v-if="productData.shipMode == 'Z'" class="info-value">直发</span>
          <span v-if="productData.shipMode == 'K'" class="info-value">库发</span>
          <span v-if="productData.shipMode == 'D'" class="info-value">断卖</span>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="12" >
          <span class="info-title">提货重量：</span>
          <span class="info-value">{{productData.billWeight}}</span>
        </van-col>
        <van-col :span="12">
          <span class="info-title">提货日期：</span>
          <span class="info-value">{{$utils.formatDate(order.billDate)}}</span>
        </van-col>
      </van-row>
      <!-- <van-row class="info-line">
        <span class="info-title">订单生成时间：</span>
        <span class="info-value">{{ order.createTime }}</span>
      </van-row> -->
    </div>
    <!-- <div class="info seller-info van-hairline--top">
      <div class="info-header">
        <img src="@/assets/imgs/seller.png" />卖家信息
      </div>
      <van-row class="info-line">
        <span class="info-title">卖家：</span>
        <span class="info-value">{{ order.sellerEnterpriseName }}</span>
      </van-row>
      <van-row class="info-line">
        <span class="info-title">联 系 人 ：</span>
        <span class="info-value">{{ order.sellerEnterpriseName }}</span>
      </van-row>
      <van-row class="info-line">
         <span class="info-title">联系电话：</span>
         <span class="info-value">{{ order.buyerContactTel }}</span>
      </van-row>
    </div> -->
    <!-- <div class="info buyer-info van-hairline--top">
      <div class="info-header">
        <img src="@/assets/imgs/buyer.png" />买家信息
      </div>
      <van-row class="info-line">
        <span class="info-title">公司名称：</span>
        <span class="info-value">{{order.buyerEnterpriseName}}</span>
      </van-row>
      <van-row class="info-line">
         <span class="info-title">联 系 人 ：</span>
         <span class="info-value">{{order.auditUserName}}</span>
      </van-row>
      <van-row class="info-line">
        <span class="info-title">联系电话：</span>
        <span class="info-value">{{order.buyerContactTel}}</span>
      </van-row>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "OrderInfoCardDetail",
  props: {
    order: Object,
    productData: Object,
  },
  data() {
    return {};
  },
  filters: {
    convertStatus: function (value) {
      switch (value) {
        case "JH":
          return "计划";
        case "JJ":
          return "竞拍";
        case "PD":
          return "拼单";
        case "SG":
          return "闪购";
        case "CH":
          return "现货";
      }
    },
  },
  computed: {
   
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  margin-buttom: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      line-height: 54px;
    }
  }

  .buyer-info, .seller-info {
    .info-line {
      color: #666666;
    }
  }
}
</style>
